import { get } from 'lodash';
import { connect } from 'react-redux';

import PdpAddToCart from 'components/PdpAddToCart';
import {
  CAMPAIGN_IDENTIFIERS,
  CAMPAIGN_NAMES,
  PDP_ADD_TO_CART_MODAL_REC_OPTIONS,
} from 'constants/personalizations';
import * as actions from 'state/actions';
import { ADD_TO_CART_ANALYTICS_ORIGINS } from 'state/constants';
import ExperimentsSelector from 'state/selectors/experiments';
import { getHasSignedUpForProductUpdates } from 'state/selectors/mailing';
import { getCurrentVariant, getCurrentProduct, getSelectedQuantity } from 'state/selectors/pdp';
import PersonalizationsSelector from 'state/selectors/personalizations';
import Settings from 'utils/Settings';

const mapStateToProps = (state, ownProps) => {
  const { policyText, features, bulkAddOptions } = ownProps;

  const currentVariant = getCurrentVariant(state);
  const currentProduct = getCurrentProduct(state);
  const isProductUpdatesEnabled =
    get(currentProduct, 'enableBackInStockEmail', false) && !getHasSignedUpForProductUpdates(state);
  const showAfterpayBeneathAddToCart = Settings.pdpAfterpayEnabled;
  const isAddToCartModalEnabled = ExperimentsSelector.isAddToCartModalEnabled(state);
  const recommendationsOption = ExperimentsSelector.addToCartModalRecommendationsOption(state);
  const selectedQuantity = getSelectedQuantity(state);

  // PDP Shop Pay DY
  const pdpShopPayVariationData = PersonalizationsSelector.getCampaignVariationData(
    state,
    CAMPAIGN_NAMES.PDP_SHOP_PAY
  );

  const showShopPay =
    !currentProduct?.isGiftCard &&
    currentVariant?.available &&
    pdpShopPayVariationData?.payload?.data?.[CAMPAIGN_IDENTIFIERS.SHOW_PDP_SHOP_PAY];

  const shopPayCampaignData = showShopPay
    ? {
        decisionId: pdpShopPayVariationData.decisionId,
        variationId: pdpShopPayVariationData.analyticsMetadata?.variationId,
        experienceName: pdpShopPayVariationData.analyticsMetadata?.experienceName,
        campaignName: pdpShopPayVariationData.analyticsMetadata?.campaignName,
      }
    : null;

  return {
    product: currentProduct,
    currentVariant,
    variantId: get(currentVariant, 'id', null),
    isBackordered: get(currentVariant, 'backordered', false),
    isSoldOut: !get(currentVariant, 'available', false),
    isProductUpdatesEnabled,
    policyText,
    selectedQuantity,
    features: {
      ...features,
      showAfterpayBeneathAddToCart,
      showShopPay,
    },
    isAddToCartModalEnabled,
    bulkAddOptions,
    recommendationsOption,
    shopPayCampaignData,
  };
};

const mapDispatchToProps = dispatch => ({
  addLineItems: (variantId, selectedQuantity, cartMetadata) =>
    dispatch(
      actions.addLineItems(
        { [variantId]: selectedQuantity },
        {
          targetSelector: cartMetadata?.targetSelector,
          origination: ADD_TO_CART_ANALYTICS_ORIGINS.PDP,
          lineItemProperties: cartMetadata?.lineItemProperties,
        }
      )
    ),
  selectQuantity: quantity => dispatch(actions.selectQuantity(quantity)),
  openProductUpdatesModal: () => dispatch(actions.openPdpUpdateFormModal()),
  openAddToCartModal: recommendationsOption => {
    dispatch(actions.openAddToCartModal());
    if (recommendationsOption !== PDP_ADD_TO_CART_MODAL_REC_OPTIONS.CONTENTFUL_UPSELLS) {
      dispatch(actions.fetchPersonalizations({ names: [recommendationsOption] }));
    }
  },
  openPdpColorwayUpdatesFormModal: () => dispatch(actions.openPdpColorwayUpdatesFormModal()),
});

const mergeProps = (stateProps, dispatchProps) => ({
  addToCart: (cartMetadata, isAddToCartModalEnabled, recommendationsOption) => {
    dispatchProps.addLineItems(stateProps.variantId, stateProps.selectedQuantity, cartMetadata);
    if (isAddToCartModalEnabled) {
      dispatchProps.openAddToCartModal(recommendationsOption);
    }
  },
  selectQuantity: quantity => {
    dispatchProps.selectQuantity(quantity);
  },
  openProductUpdatesModal: dispatchProps.openProductUpdatesModal,
  openPdpColorwayUpdatesFormModal: dispatchProps.openPdpColorwayUpdatesFormModal,
  ...stateProps,
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(PdpAddToCart);
